import React, { useContext, useEffect, useRef, useState } from 'react'
import styles from '../styles/modal.module.css'
import { toast } from 'react-toastify';
import StateContext from '../context/state/StateContext';
import UserContext from '../context/user/UserContext';
import axios from 'axios';
import { FaLink } from "react-icons/fa6";
import { AiOutlineFolderOpen } from "react-icons/ai";
import { IoMdAlarm } from "react-icons/io";
import { IoAdd } from "react-icons/io5";
import { IoCloseOutline } from "react-icons/io5";
import { IoFlag } from "react-icons/io5";
import { IoCheckmarkSharp } from "react-icons/io5";
import Links from './Links';
import useVoiceRecorder from './useVoiceRecorder';
import { FaRegCircleStop } from "react-icons/fa6";
import { IoIosMic } from "react-icons/io";
import CustomReminder from './CustomReminder';
import { IoSearch } from "react-icons/io5";
import Fuse from 'fuse.js';
import Dropdown from './Dropdown';


const UpdatTicket = (props) => {

    const { isRecording, audioBlob, startRecording, stopRecording } = useVoiceRecorder();
    const { ticket, setTicket, groupDetails, reminderData, token, ticketIds, setReminderData, tickets, setTickets, employees, setLoading, setDetail } = useContext(StateContext)
    const { user, getEmployees, getClients, fetchGroupDetails } = useContext(UserContext)
    const [category, setCategory] = useState('');
    const [drop, setDrop] = useState(Array(2).fill(false));
    const [disabled, setDisabled] = useState(true);
    const [assigned, setAssigned] = useState([]);
    const [status, setStatus] = useState('');
    const [dateTime, setDateTime] = useState({ date: '', time: '' });
    const [clientName, setClientName] = useState({ id: '', name: '' });
    const [error, setError] = useState('');
    const [fields, setFields] = useState({ component: '', open: false });
    const [link, setLink] = useState('');
    const [links, setLinks] = useState([]);
    const [files, setFiles] = useState([]);
    const [priority, setPriority] = useState('');
    const [group, setGroup] = useState('')
    const [allEmployees, setAllEmployees] = useState([]);
    const [repeat, setRepeat] = useState('does_not_repeat')
    const [acknowledge, setAcknowledge] = useState({
        employees: [],
        assigned: []
    })

    const [repeatChecked, setRepeatChecked] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');

    const [filteredGroups, setFilteredGroups] = useState([]);
    const [filteredEmployees, setFilteredEmployees] = useState([]);


    const searchDropRef = useRef(null);
    const searchGroupRef = useRef(null);

    const fuse = new Fuse(allEmployees, {
        keys: ['username'], // Search by the 'name' key
        threshold: 0.4, // Fuzzy match threshold (lower = stricter matches)
    });

    const handleSearch = (event) => {
        const query = event.target.value;
        setSearchQuery(query);

        if (query.trim() === '') {
            setFilteredEmployees(allEmployees);
        } else {
            const results = fuse.search(query);
            setFilteredEmployees(results.map(result => result.item));
        }
    };

    // group filter code hrere 

    const fuse1 = groupDetails && new Fuse(groupDetails, {
        keys: ['name'], // Search by the 'name' key
        threshold: 0.4, // Fuzzy match threshold (lower = stricter matches)
    });


    const [groupQuery, setGroupQuery] = useState('');

    const handleGroupSearch = (event) => {
        const query = event.target.value;
        setGroupQuery(query);

        if (query.trim() === '') {
            setFilteredGroups(groupDetails);
        } else {
            const results = fuse1.search(query);
            setFilteredGroups(results.map(result => result.item));
        }
    };


    const categoryDrop = (category) => {
        setDisabled(false)
        setCategory(category)
        setDrop(false)
    }

    const handleDrop = (index) => {
        const array = [...drop]
        array[index] = !drop[index]
        setDrop(array)
    }

    const assignedDrop = (id, name, action) => {
        const current = { id: id, name: name }
        if (action === 'add') {
            // Add the item to the assigned list
            setAssigned(prev => [...prev, { id, name }]);
        } else if (action === 'remove') {
            // Remove the item from the assigned list
            setAssigned(prev => prev.filter(item => item.name !== name));
        }
        setDisabled(false)
        // setDrop(false)
        setError('')
    }


    const handleChange = (e) => {
        setDisabled(false)
        setTicket({ ...ticket, [e.target.name]: e.target.value })
    }

    const handleDate = (e) => {
        setDisabled(false)
        setDateTime({ ...dateTime, [e.target.name]: e.target.value })
    }

    useEffect(() => {
        getEmployees();
        fetchGroupDetails();
        const currentTicket = tickets.find(item => item.id == ticketIds.id)
        setTicket({ title: currentTicket.title, description: currentTicket.description })
        setCategory(currentTicket.category)
        if (currentTicket.repeat) {
            setRepeat(currentTicket.repeat)
            setRepeatChecked(true)
            setReminderData(currentTicket.repeat_data)
        }
        setStatus(currentTicket.status)
        setClientName({ id: currentTicket.clientId, name: currentTicket.client_name })
        setDateTime({ date: currentTicket.date, time: currentTicket.time })
        setPriority(currentTicket.priority)
        setLinks(currentTicket.links)
    }, [])


    useEffect(() => {
        // Ensure tickets and employees exist before proceeding
        const emp = employees.filter(item => item.role !== "agency")
        setAllEmployees(emp)
        const currentTicket = tickets.find(item => item.id == ticketIds.id);
        const assignedEmployees = emp
            .filter(item => currentTicket.employeeId.includes(item.id))
            .map(item => ({ id: item.id, username: item.username }));
        const acknowledgeEmployees = emp
            .filter(item => currentTicket.acknowledgeId.includes(item.id))
            .map(item => ({ id: item.id, username: item.username }));
        setAssigned(assignedEmployees);
        setAcknowledge({ employees: emp.filter(item => !assignedEmployees.map(assigned => assigned.id).includes(item.id)), assigned: acknowledgeEmployees })
        setFilteredGroups(groupDetails)
        setFilteredEmployees(emp)
    }, []); // Add these as dependencies


    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const formData = new FormData();
            formData.append('ticketId', ticketIds.id);
            formData.append('title', ticket.title);
            formData.append('clientId', ticketIds.clientId);
            formData.append('description', ticket.description);
            formData.append('category', category);
            formData.append('employeeId', JSON.stringify(assigned.map(emp => emp.id)));
            formData.append('acknowledgeId', JSON.stringify(acknowledge.assigned.map(emp => emp.id)));
            formData.append('employee_name', assigned.name);
            formData.append('date', dateTime.date);
            formData.append('time', dateTime.time);
            formData.append('links', JSON.stringify(links));
            formData.append('priority', priority);
            formData.append('group', group.id);

            if (audioBlob !== null) {
                formData.append('audio', audioBlob, 'voice-recording.wav');
            }

            for (let i = 0; i < files.length; i++) {
                formData.append('uploads', files[i]);
            }
            formData.append("repeat", repeat)
            if (reminderData !== null) {
                formData.append('repeatData', JSON.stringify(reminderData))
                setReminderData(null);
            }


            setLoading({ open: true, text: 'Saving...' })
            const response = await axios.post(process.env.REACT_APP_API_URL + "api/ticket/update",
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'auth-token': `${token}`
                    },
                })

            const json = response.data;
            if (json.success) {
                toast.success(json.message)
                setTickets(prevTickets =>
                    prevTickets.map(ticket =>
                        ticket.id === ticketIds.id ? {...json.updatedTicket } : ticket
                    )
                );
                setDetail({open: true, detail: json.updatedTicket})
                props.close(false)
            } else {
                toast.error(json.message)
                setError(json.message || json.message[0].msg)
            }

        } catch (error) {
            console.log(error);
            // setError(error.response.data.message || error.response.data.message[0].msg)
            toast.error(error)
        } finally {
            setLoading({ open: false, text: '' })
        }
    }

    const handleStatus = (state) => {
        setDisabled(false)
        setStatus(state)
    }

    const todayDate = () => {
        let date = new Date();
        return date.getDate();
    };

    const smallComponent = () => {
        if (fields.component === "links") {
            return <Links close={setFields} disabled={setDisabled} open={fields} link={link} setLink={setLink} links={links} setLinks={setLinks} />
        } if (fields.component === "custom") {
            return <CustomReminder close={setFields} open={fields} />
        }
    }

    const handleFileChange = (event) => {
        const fileList = event.target.files;

        // Convert FileList to Array and limit it to 5 files
        // const fileArray = Array.from(fileList).slice(0, 5);

        if (fileList.length > 5) {
            setError('You can only upload a maximum of 5 files.');
        } else {
            setError('');
            setDisabled(false)
            setFiles(fileList); // Update state with valid files
        }
    };

    const handleAcknowledge = (current, action) => {
        const { id, username } = current;
        if (action === 'add') {
            // Add the item to the assigned list
            setAcknowledge((prev) => {
                return { 
                    ...prev,
                    assigned: [...prev.assigned, {id, username }]
                }
            });
        } else if (action === 'remove') {
            // Remove the item from the assigned list
            setAcknowledge((prev) => {
                return { 
                    ...prev,
                    assigned: prev.assigned.filter(item => item.username !== username)
                }
            });
        }
        setDisabled(false)
        setError('')
    }

    const handleGroupClick = (current, action) => {
        const teamEmployees = employees.filter(item => item.role !== "agency");

        if (!current) {
            setAllEmployees(teamEmployees);
            setAssigned([]);
            setGroup([]);
            return;
        }

        if (action === 'add') {
            setGroup(prev => [...prev, { id: current.id, name: current.name }]);

            const groupUsers = current.users
            .map(userRef => teamEmployees.find(emp => emp.id === userRef.id))
            .filter(Boolean); // remove nulls

            const assignedList = groupUsers.map(({ id, username }) => ({ id, username }));

            // Reorder groupUsers: assigned users first
            const orderedUsers = [...allEmployees].sort((a, b) => {
            const aAssigned = assignedList.find(user => user.id === a.id);
            const bAssigned = assignedList.find(user => user.id === b.id);
            return aAssigned && !bAssigned ? -1 : !aAssigned && bAssigned ? 1 : 0;
            });

            setAssigned(assignedList);
            setAllEmployees(orderedUsers);

        } else if (action === 'remove') {
            setGroup(prev => prev.filter(g => g.id !== current.id));

                // Remove assigned users that belong to this group
            const groupUserIds = current.users.map(user => user.id);

            setAssigned(prev =>
                prev.filter(user => !groupUserIds.includes(user.id))
            );
        }
    };

    const today = new Date();
    const dayOfWeek = today.toLocaleString('default', { weekday: 'long' });

    const monthNames = ["January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    const getNthWeekday = (date) => {
        const dayOfWeek = date.getDay(); // Sunday is 0, Monday is 1, etc.
        const dayOfMonth = date.getDate();

        // Calculate how many times this day has occurred so far in the month
        const nthOccurrence = Math.ceil(dayOfMonth / 7);

        // Array to map weekday numbers to names
        const weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

        return `${nthOccurrence} ${weekdays[dayOfWeek]}`; // e.g., "2nd Monday"
    };

    return (
        <>
            <div className={`${styles.smallDrop} ${fields.open ? styles.active : ''} `}></div>
            <div className={`${styles.small_modal} ${fields.open ? styles.active : ''}`}>
                {smallComponent()}
            </div>
            <div className={styles.head}>
                <h3>Update Task</h3>
                <i className={`bx bx-x ${styles.close}`} onClick={() => props.close(false)}></i>
            </div>
            <form action="" className='h-100' onSubmit={handleSubmit}>
                <div className={styles.form_container}>
                    <div className="inputField" style={{ border: "1px solid #ddd" }}>
                        <input type="text" name='title' placeholder='Enter a Title*' value={ticket.title} onChange={handleChange} />
                    </div>
                    <div className="row">
                        <div className="col-md-6 col-12">
                            <div className="inputField" style={{ border: "1px solid #ddd" }}>
                                <input type="text" name='category' value={category} placeholder='Enter a category*' onChange={(e) => { setCategory(e.target.value) }} required />
                            </div>
                        </div>
                        <div className="row pe-0">
                            <label htmlFor="" className='mb-1 label fw-semibold'>Add User or a Group</label>
                            <div className="col-md-6 col-12 pe-0">
                                <Dropdown
                                    style={{zIndex: "9999"}}
                                    items={groupDetails}
                                    assigned={group}
                                    labelKey="name"
                                    title="Select Groups"
                                    placeholder="Search groups..."
                                    fuseKeys={["name"]}
                                    idPrefix = "group"
                                    assignedDrop={handleGroupClick}
                                    />
                            </div>
                            <div className="col-md-6 col-12 pe-0" >
                                <Dropdown
                                    style={{zIndex: "999"}}
                                    items={allEmployees}
                                    assigned={assigned}
                                    labelKey="username"
                                    title="Assign Employees"
                                    placeholder="Search employees..."
                                    fuseKeys={["username"]}
                                    idPrefix = "employee"
                                    assignedDrop={assignedDrop}
                                    />
                            </div>
                            <div className="col-md-6 col-12 pe-0">
                                <Dropdown
                                    style={{zIndex: "99"}}
                                    items={acknowledge.employees}
                                    assigned={acknowledge.assigned}
                                    labelKey="username"
                                    title="Assign Acknowledged Employees"
                                    placeholder="Search employees..."
                                    fuseKeys={["username"]}
                                    idPrefix = "acknowledge"
                                    assignedDrop={handleAcknowledge}
                                    />
                            </div>
                        </div>
                    </div>
                    <div className="inputField" style={{ border: "1px solid #ddd", borderRadius: "30px", borderRadius: "12px" }}>
                        <textarea name="description" value={ticket.description} onChange={handleChange} id="" placeholder='Enter a Description*' rows={5}></textarea>
                    </div>
                    <div className="row">
                        <label htmlFor="" className='mb-1 label fw-semibold'>Due Date</label>
                        <div className="col-md-6 col-12">
                            <div className="inputField" style={{ border: "1px solid #ddd" }}>
                                <input type="date" placeholder='Select Date' name='date' max={todayDate} value={dateTime.date} onChange={handleDate} />
                            </div>
                        </div>
                        <div className="col-md-6 col-12">
                            <div className="inputField" style={{ border: "1px solid #ddd" }}>
                                <input type="time" placeholder='Select Time' name='time' value={dateTime.time} onChange={handleDate} />
                            </div>
                        </div>
                    </div>
                    <div className={styles.repeat}>
                        <div className="checkbox-wrapper-4">
                            <input
                                type="checkbox"
                                checked={repeatChecked}
                                className="inp-cbx"
                                onChange={() => setRepeatChecked(!repeatChecked)}  // Toggle checkbox state
                                id="repeat-checkbox"  // Unique id for input
                            />
                            <label htmlFor="repeat-checkbox" className="cbx">
                                <span><svg></svg></span>
                                <span className='text'>Repeat</span>
                            </label>
                        </div>

                        {/* Conditionally render the dropdown based on the checkbox state */}
                        {repeatChecked && (
                            <div className={`w-100 dropdown ${drop[0] ? 'active' : ''}`}
                                onClick={() => handleDrop(0)}>
                                <div className="select">
                                    <div className="d-flex align-items-center">
                                        <span>{repeat ? repeat : "Does Not Repeat"}</span>
                                    </div>
                                    <i className="fa-solid fa-angle-up"></i></div>
                                <ul>
                                    <li onClick={() => { setRepeat("does_not_repeat"); setDisabled(false) }}>Does not repeat</li>
                                    <li onClick={() => { setRepeat("daily"); setDisabled(false) }}>Daily</li>
                                    <li onClick={() => { setRepeat("weekly"); setDisabled(false) }}>Weekly on {dayOfWeek}</li>
                                    <li onClick={() => { setRepeat("monthly"); setDisabled(false) }}>Monthly on the {getNthWeekday(new Date())}</li>
                                    <li onClick={() => { setRepeat("weekday"); setDisabled(false) }}>Every weekday (Monday to Friday)</li>
                                    <li onClick={() => { setRepeat("custom"); setFields({ component: 'custom', open: true }); setDisabled(false) }}>Custom Recurrence</li>
                                </ul>
                            </div>
                        )}
                    </div>
                    {error ? <p style={{ color: "red" }}>{error}</p> : null}
                    <div className="inputField priority" style={{ gap: "6px" }}>
                        <span className={styles.tag}>
                            <IoFlag />
                            <p>Priority</p>
                        </span>
                        <span onClick={() => { setPriority('High'); setDisabled(false) }} className={`${styles.tag} ${priority == "High" ? styles.active : ""}`}>
                            <IoCheckmarkSharp />
                            <p>High</p>
                        </span>
                        <span onClick={() => { setPriority('Medium'); setDisabled(false) }} className={`${styles.tag} ${priority == "Medium" ? styles.active : ""}`}>
                            <IoCheckmarkSharp />
                            <p>Medium</p>
                        </span>
                        <span onClick={() => { setPriority('Low'); setDisabled(false) }} className={`${styles.tag} ${priority == "Low" ? styles.active : ""}`}>
                            <IoCheckmarkSharp />
                            <p>Low</p>
                        </span>
                    </div>
                    <p className={styles.para}>You can upload up to 5 files</p>
                    <div className="d-flex align-items-center flex-wrap" style={{ gap: "15px" }}>
                        <div className={styles.icon} data-attr="Add Links" onClick={() => { setFields({ component: "links", open: true }) }}>
                            {links.length > 0 && <span>{links.length}</span>}
                            <FaLink />
                        </div>
                        <label htmlFor='upload' className={styles.icon} data-attr="Upload Files">
                            <input type="file" style={{ display: "none" }} onChange={handleFileChange} multiple id='upload' />
                            <AiOutlineFolderOpen />
                        </label>
                        {files.length > 0 ?
                            <div className={styles.files}>
                                {Array.from(files).map((item, index) => {
                                    return <span key={index} className={styles.file}>{item.name}{files.length > index ? ',' : null}</span>
                                })}
                            </div> : null}
                        {!isRecording ? (
                            <div className={styles.icon} data-attr="Start Recording" onClick={() => { startRecording(); setDisabled(false) }}>
                                <IoIosMic />
                            </div>
                        ) : (
                            <div className={styles.icon} data-attr="Stop Recording" onClick={stopRecording}>
                                <FaRegCircleStop />
                            </div>
                        )}
                        {audioBlob && (
                            <div>
                                <audio controls src={URL.createObjectURL(audioBlob)} />
                            </div>
                        )}
                    </div>
                </div>
                <div className={styles.foot}>
                    <div className="d-flex align-items-center" style={{ gap: "20px" }}>
                        <button type='button' className="button2 cancel" onClick={() => props.close(false)}>Cancel</button>
                        <button type='submit' className={`button2 ${disabled ? 'disabled' : ''}`} disabled={disabled}>Update</button>
                    </div>
                </div>
            </form>

        </>
    )
}

export default UpdatTicket
